import {Component, forwardRef} from "@angular/core";
import {SelectOptionsComponent} from "../../../framework/entity/select/options/select-options.component";
import {TranslateService} from "@ngx-translate/core";
import {KvdDocketTimerType} from "../order-processor.data";

@Component({
    selector: "wbo-kvd-docket-timer-type-select-options",
    templateUrl: "./kvd-docket-timer-type-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => KvdDocketTimerTypeSelectOptionsComponent),
        multi: true
    }]
})
export class KvdDocketTimerTypeSelectOptionsComponent extends SelectOptionsComponent {
    KvdDocketTimerType = KvdDocketTimerType;

    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
